class CloudPayments {
    create({ publicId, description, accountId, invoiceId, amount, currency, email }) {
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.dataset.name = "cloudpayments-agent";
        script.src = "https://widget.cloudpayments.ru/bundles/cloudpayments";
        document.getElementsByTagName("head")[0].appendChild(script);

        return new Promise((resolve, reject) => {
            script.onload = () => {
                window._startPayMadRobots = () => {
                    let widget = new window.cp.CloudPayments({ language: "ru-RU" });
                    widget.pay(
                        "charge",
                        {
                            publicId,
                            description,
                            accountId,
                            invoiceId,
                            amount: Number(amount),
                            currency,
                            email,
                        },
                        {
                            onSuccess: (success) => resolve(success),
                            onFail: (error) => reject(error),
                        }
                    );
                };
                window._startPayMadRobots();
            };
        });
    }

    open() {
        if (typeof window._startPayMadRobots === "function") {
            window._startPayMadRobots();
        }
    }

    destroy() {
        const script = document.head.querySelector("[data-name=cloudpayments-agent]");
        if (script) {
            document.head.removeChild(script);
        }
    }
}

const cloudPayments = new CloudPayments();
export { cloudPayments };
